import * as React from "react";
import { useFormContext } from "react-hook-form";
import { Modal, Select } from "components";
import { SpeciesEnum, WeightMeasureEnum } from "requests";
import { Types } from "../../duck";
import { SPECIES_OPTIONS } from "./duck";

interface SpeciesProps {
  defaultValue: SpeciesEnum | null;
}

const Species: React.FC<SpeciesProps> = ({ defaultValue }) => {
  const { setValue } = useFormContext<Types.FormValues>();

  return (
    <Select
      name="species"
      label="Species"
      onChange={(value: SpeciesEnum | null) => {
        if (
          (value === SpeciesEnum.Dog || value === SpeciesEnum.Cat || !value) &&
          defaultValue !== SpeciesEnum.Rabbit
        ) {
          setValue("weightMeasure", WeightMeasureEnum.Lbs);
        } else if (
          defaultValue !== SpeciesEnum.Dog &&
          defaultValue !== SpeciesEnum.Cat &&
          defaultValue !== SpeciesEnum.Rabbit
        ) {
          setValue("weightMeasure", WeightMeasureEnum.G);
        }

        if (
          !defaultValue ||
          (defaultValue !== SpeciesEnum.Dog &&
            defaultValue !== SpeciesEnum.Cat &&
            defaultValue !== SpeciesEnum.Rabbit)
        ) {
          setValue("species", value);
          setValue("breed", null);
          return;
        }

        if (value !== defaultValue) {
          Modal.instance.open({
            title: `Remove ${defaultValue} data`,
            description:
              "Are you sure you want to change this species? Data connected with this species will be deleted and you will not be able to undo this action.",
            onOk() {
              setValue("species", value);
              setValue("breed", null);
              if (
                value === SpeciesEnum.Dog ||
                value === SpeciesEnum.Cat ||
                !value
              ) {
                setValue("weightMeasure", WeightMeasureEnum.Lbs);
              } else {
                setValue("weightMeasure", WeightMeasureEnum.G);
              }
            }
          });
        }
      }}
      placeholder="Species"
      options={SPECIES_OPTIONS}
    />
  );
};

export default Species;
